var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{attrs:{"appTitle":"测试2"}}),_c('Examine',{key:_vm.index,ref:"Examine",attrs:{"type":"0","id":"ERP_SHIPPING_APPLY"},on:{"submitProcess":_vm.submitProcess,"getUserState":_vm.getUserState}}),_c('div',{on:{"click":_vm.indexChange}},[_vm._v("1")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }